import _ from 'lodash';
import Axios, { AxiosRequestConfig } from 'axios';
import history from '../history';

Axios.interceptors.response.use(response => {

    return response;

}, error => {

    const excludes = ['/login', '/register', '/verifyemail', '/recoverypassword', '/changepassword', '/removeaccount', '/stripe/intent'];

    if (_.get(error, 'response.status', 0) === 401 && !!!_.find(excludes, exclude => error.config.url.includes(exclude))) {

        window.localStorage.removeItem('jwt');
        history.push('/auth/login?expired=true');

    }

    throw error;

});

const getOptions = (requireToken: boolean, isBlob: boolean = false, isFile: boolean = false) => {

    const options: AxiosRequestConfig = { headers: {} };

    if (requireToken && window.localStorage.getItem('jwt')) {

        options.headers = isFile ? { 'x-access-token': window.localStorage.getItem('jwt') || '', 'Content-Type': 'multipart/form-data' } : { 'x-access-token': window.localStorage.getItem('jwt') || '' };

    }

    if (isBlob) {

        options.responseType = 'blob';

    }

    return options;

};

const get = (apiEndpoint: string, requireToken: boolean) => Axios.get(apiEndpoint, getOptions(requireToken)).catch(err => { throw err.response && err.response.status; });
const getBlob = (apiEndpoint: string, requireToken: boolean) => Axios.get(apiEndpoint, getOptions(requireToken, true)).catch(err => { throw err.response && err.response.status; });
const post = (apiEndpoint: string, payload: any, requireToken: boolean) => Axios.post(apiEndpoint, payload, getOptions(requireToken)).catch(err => { throw err.response && err.response.status; });
const put = (apiEndpoint: string, payload: any, requireToken: boolean) => Axios.put(apiEndpoint, payload, getOptions(requireToken)).catch(err => { throw err.response && err.response.status; });
const deleting = (apiEndpoint: string, requireToken: boolean) => Axios.delete(apiEndpoint, getOptions(requireToken)).catch(err => { throw err.response; });
const postFile = (apiEndpoint: string, payload: any, requireToken: boolean) => Axios.post(apiEndpoint, payload, getOptions(requireToken, false, true)).catch(err => { throw err.response && err.response.status; });

const exports = {
    get,
    getBlob,
    post,
    put,
    deleting,
    postFile
}

export default exports;